import { Button, Icon, Input, Tooltip } from "@alpaca/framework";
import "./inviteUserStep.styles.scss";
import { useEffect, useState } from "react";
import UserPermission from "../../../user/permission/permission.component";
import { isEmailFormat } from "../../../../pages/register/components/register-form/register-form.util";

import { ReactComponent as NoInvitesAdded } from "../../../../assets/graphics/NoInvitesAdded.svg";

const PermissionTag = ({ permission }) => {
  return <div className="inviteUserSummaryPermissionTag">{permission}</div>;
};

const InviteUserStep = ({
  permissions: incomingPermissions,
  invites,
  setInvites,
}) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const permissionsChosen = permissions.filter((perm) => perm.isGranted);

  const [canAddUser, setCanAddUser] = useState(false);
  const [inputEmail, setInputEmail] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (incomingPermissions && incomingPermissions.length > 0) {
      setPermissions(incomingPermissions);
      setLoading(false);
    }
  }, [incomingPermissions]);

  useEffect(() => {
    if (inputEmail && permissionsChosen.length > 0) {
      setCanAddUser(true);
    } else {
      setCanAddUser(false);
    }
  }, [inputEmail, permissionsChosen]);

  const handlePermissionChange = (index, isGranted) => {
    setPermissions((prevPermissions) => {
      return prevPermissions.map((perm, i) =>
        i === index ? { ...perm, isGranted } : { ...perm }
      );
    });
  };

  const handleAddUser = () => {
    const email = String(inputEmail);

    if (!isEmailFormat(email)) {
      setError("Invalid email format.");
      return;
    }

    // Check for duplicate emails
    if (invites.some((invite) => invite.email === inputEmail)) {
      setError("This email has already been invited.");
      return;
    }

    const newInvite = {
      email: inputEmail,
      permissions: permissionsChosen,
    };

    setInvites((prevInvites) => [...prevInvites, newInvite]);
    setInputEmail("");
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm) => ({ ...perm, isGranted: false }))
    );
    setError(null);
  };

  const handleDeleteInvite = (emailToDelete) => {
    setInvites((prevInvites) =>
      prevInvites.filter((invite) => invite.email !== emailToDelete)
    );
  };

  return (
    <>
      <div className="inviteUserSTepContainer">
        <div className="inviteUserGridContainer">
          {/* <div className="invite__user__step__option"> */}
          <div className="inviteUserGirdItem">
            <h4 className="cardHeading">Details</h4>
            <div className="inviteUserGridItemContentContainer">
              <label className="ant-form-item-label" htmlFor="email">
                Email
              </label>
              <Input
                id="email"
                onChange={(e) => setInputEmail(e.target.value)}
                value={inputEmail}
                placeholder="Enter email address"
              />
            </div>
          </div>

          <div className="inviteUserGirdItem">
            <h4 className="cardHeading">Permissions</h4>
            <div className="inviteUserGridItemContentContainer">
              <div className="invite__user__checkbox__container">
                {loading ? (
                  <p>Loading permissions...</p>
                ) : (
                  <UserPermission
                    permissions={permissions}
                    onChange={handlePermissionChange}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="inviteUserGirdItem">
            <h4 className="cardHeading">Summary</h4>
            <div className="inviteUserGridItemContentContainer">
              {invites.length === 0 && (
                <div className="noInvitesAddedContainer">
                  <NoInvitesAdded width={150} />
                  <p className="bodyTextLarge">No Invites Added Yet</p>
                  <p className="bodyTextSmall textCentre">
                    Add an email and select permissions to invite a user.
                  </p>
                </div>
              )}

              {invites.map((invite) => (
                <div className="inviteUserSummaryItem" key={invite.email}>
                  <div className="inviteUserSUmmaryDetails">
                    <p className="bodyTextLarge">{invite.email}</p>
                    <div className="inviteUserPermissionsContainer">
                      {invite.permissions.map((item) => (
                        <PermissionTag
                          key={item.permission_group_name}
                          permission={item.permission_group_name}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="inviteUserSummaryActions">
                    <Tooltip title="Remove this Invite?">
                      <Button
                        danger
                        icon={<Icon icon="trash" />}
                        onClick={() => handleDeleteInvite(invite.email)}
                      />
                    </Tooltip>
                  </div>
                </div>
              ))}
            </div>

            {invites.length > 0 && (
              <div className="inviteUserSummaryCount">
                <h4>{invites.length} Invite(s) to Send</h4>
              </div>
            )}
          </div>
        </div>
        {/* </div> */}

        {error && <p className="error">{error}</p>}

        <div className="inviteUserAddBtnContainer">
          <Button
            disabled={!canAddUser}
            onClick={handleAddUser}
            size="large"
            type="primary"
          >
            Add User
          </Button>
        </div>
      </div>
    </>
  );
};

export default InviteUserStep;
